import React from "react";

import styles from "./IconButton.module.scss";

interface IconButtonProps {
  children?: React.ReactNode;
  onClick: () => void;
  color?: keyof typeof colorMap;
  hoverColor?: keyof typeof colorMap;
}

const colorMap = {
  default: "#878787", // Matches $dark-gray
  red: "#E72828", // Matches $red
  green: "#41BA5F", // Matches $green
};

const IconButton = ({
  children,
  onClick,
  color = "default",
  hoverColor = "default",
}: IconButtonProps) => {
  return (
    <button
      className={styles.button}
      style={
        {
          "--normal-color": colorMap[color],
          "--hover-color": colorMap[hoverColor],
        } as React.CSSProperties
      }
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default IconButton;
